import React from 'react';
import Skeleton from '../../Components/Skeleton';

/** Loading stand-in for ParkingAreasOverview: two buildings with a few area buttons each. */
export const ParkingAreasSkeleton: React.FC = () => (
    <div className="parking-tab-content std-box">
        {[0, 1].map(b => (
            <section key={b} className="parking-building-section">
                <h2 className="parking-section-title"><Skeleton width="38%" /></h2>
                <div className="parking-area-cards">
                    {[0, 1, 2].slice(0, b === 0 ? 3 : 2).map(i => (
                        <div key={i} className="parking-area-card" aria-busy="true">
                            <div className="parking-area-card-drawing"><Skeleton width="100%" height="100%" /></div>
                            <div className="parking-area-card-body">
                                <Skeleton width="60%" height="1.1em" className="mb-2" />
                                <Skeleton width="85%" height="0.85em" />
                            </div>
                        </div>
                    ))}
                </div>
            </section>
        ))}
    </div>
);

const COLUMN_WIDTHS = ['70%', '60%', '30%', '75%', '85%', '65%', '90%'];

/** Loading stand-in for ParkingQueueBoard: action row, view bar and a table with the real column headings. */
export const ParkingQueueSkeleton: React.FC = () => (
    <div className="parking-queue-page">
        <div className="parking-tab-content std-box">
            <div className="parking-tab-content-header">
                <div className="parking-queue-viewbar">
                    <Skeleton width="140px" height="38px" />
                    <Skeleton width="320px" height="0.9em" />
                </div>
                <div className="parking-queue-actions">
                    <Skeleton width="128px" height="38px" />
                </div>
            </div>
            <div className="parking-tab-content-body">
                <table className="table parking-queue-table">
                    <thead><tr>
                        <th>Sökande</th><th>Intern/extern</th><th>Platser idag</th><th>Ködatum</th><th>Önskemål</th><th>Senast rörd</th><th>Senaste anteckning</th>
                    </tr></thead>
                    <tbody>
                        {[0, 1, 2, 3, 4].map(row => (
                            <tr key={row} className="parking-queue-row parking-queue-row-skeleton">
                                {COLUMN_WIDTHS.map((width, col) => (
                                    <td key={col}><Skeleton width={width} /></td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    </div>
);
